// eslint:disable:no-http-string
import * as React from 'react';
import { Link as LinkRouter } from 'react-router-dom';
import Linkify from 'react-linkify';
import { Link, SingleValueComponent } from 'ui';
import tlds from 'tlds';

export const linkify = require('linkify-it')();

linkify.tlds(tlds);
linkify   
  .add('file:', 'http:')              // Add `file:` protocol  
  .add('ftps:', 'http:')              // Add `ftps:` protocol  
  .add('mailto:', null)               // Disable `mailto:` protocol    
  .set({ fuzzyLink: false,            // Don't recognize URL-s without http(s):// head.
         fuzzyEmail: false });        // Don't recognize emails without mailto

export interface DisplayTextWithLinksProps extends Partial<SingleValueComponent<string>>{
  text: string;
  className?: string;
  linkify?: boolean;
  linkRouter?: boolean;
}

export class DisplayTextWithLinks extends React.Component<DisplayTextWithLinksProps, any> {
  /**
   * Creates text with links(e.g., https://www.google.com) and named links(e.g., 'https://www.dnv.com[DNV Web]').
   */
  public static defaultProps: Partial<DisplayTextWithLinksProps> = {
    linkify: true
  };
  
  private renderHrefDecorator = (text: string) => {
    // extract string before '#[' in a named link e.g., extract 'https://www.dnv.com' from https://www.dnv.com#[DNV Web]
    const namedLinkUrl = (text?.match(/^(.+?)#\[/))?.[1]; 

    if(namedLinkUrl) {
      return namedLinkUrl;
    }
    return text;
  };

  private renderTextDecorator = (text: string) => {
    // Extract substring within box bracket i.e.,'[]' from a named link e.g. extract 'DNV Web' from https://www.dnv.com#[DNV Web]
    // and then if exists, replace '$@$' by space to restore original text meant to be the name for any valid link
    //'$@$' will only exist if named link contains spaces e.g. [DNV Web] as handled in the render section
    const namedLinkText = (text?.match(/\[(.*?)\]/))?.[1].replace(/(\$\@\$)/g, ' ');

    if(namedLinkText) {
      return namedLinkText;
    }
    return text;
  };

  private renderLink = (decoratedHref: string, decoratedText: string, key: number) => {
    return (
      this.props.linkRouter
        ? <LinkRouter to={decoratedHref}>
          {decoratedText}
        </LinkRouter>
        : <Link url={decoratedHref}
          key={key}>
          {decoratedText}
        </Link>);
  };

  private matchLinks = (text: string): object[] => {
    return linkify.match(text);
  };

  private linkifyValidUrls = (text: string) => {
    return this.props.linkify ? 
      <Linkify matchDecorator={this.matchLinks} componentDecorator={this.renderLink}
        hrefDecorator={this.renderHrefDecorator} textDecorator={this.renderTextDecorator}>
          {text}
      </Linkify> : text;
  };

  public render() {
    const {componentId, className, text} = this.props;

    let overrideText;

    //This is to handle a bug with react-linkify which does not handle named links having spaces e.g. [DNV Web]
    //If exists, replace spaces within [] by '$@$'. 
    overrideText = text?.replace(/(\s+(?=[^[\]]*\]))/g, '$@$');

    //This is to handle a bug with react-linkify which does not handle named links e.g. #[DNV] not followed by space e.g. #[DNV](Norway)
    //If exists, append space after named link otherwise can lead to missing characters in the output
    overrideText = overrideText?.replace(/#\[(.*?)\](?=\S)/g, '#[$1] ');
    
    return (
      text ? 
        <div id={componentId} className={className}>
          {this.linkifyValidUrls(overrideText)}
        </div> : null
    );}
}
